import { FormattedMessage, useIntl } from 'react-intl';

import { FormField } from '../../../../forms/formField/index';

const WebsiteQuestion = (props) => {
    const intl = useIntl();
    const { onChange } = props;

    return (
        <FormField
            label={
                <FormattedMessage
                    id="_.your_company.website"
                    defaultMessage="Website"
                />
            }
            className="fs-exclude"
            name="website"
            id="website"
            onChangeHandler={onChange}
            placeholder={intl.formatMessage({
                id: '_.your_company.website_placeholder',
                defaultMessage: 'www.example.com'
            })}
        />
    );
};

// eslint-disable-next-line import/no-default-export
export default WebsiteQuestion;
